import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../icons/x-hex.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { CustomerSupportLink } from '../buttons';
import { ReturnToBookingPortal } from './buttons';
import { InactiveTableProps, TableVariant } from './types';

export const InactiveTable = ({ linkTo, variant = 'default', tableLabel = 'table' }: InactiveTableProps) => {
	const { t } = useTranslation();

	const tableDeterminer: Record<TableVariant, string> = {
		default: t('labels.this', { defaultValue: 'this' }),
		withBooking: t('labels.your', { defaultValue: 'your' })
	};

	const guestAction: Record<TableVariant, React.ReactNode> = {
		default: (
			<p>
				{t('messages.contact_support_hesitate')} <CustomerSupportLink />.
			</p>
		),
		withBooking: (
			<p>
				{t('messages.staff_contact_shortly')} <CustomerSupportLink />
			</p>
		)
	};

	return (
		<ResultPageLayout headerIcon={ErrorIcon} iconAltText={t('titles.table_unavailable')}>
			<ResultPageLayout.Title>{t('titles.table_unavailable')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.table_removed_system', {
						determiner: tableDeterminer[variant],
						tableLabel
					})}
				</p>
				{guestAction[variant]}
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<ReturnToBookingPortal to={linkTo} />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};
